import { useTranslation } from "react-i18next"

function ErrorMessage({
    error
}) {

    const [t, i18n] = useTranslation(["global"])

    console.log("Error Status: " + error.status)
    const color = () => {
        switch (error.status) {
            case 403: return "warning";
            default: return "danger"
        }
    }

    const alerColor = color();

    let content =
        <div>
            <div className={`alert alert-${color()} alert-dismissible`} role="alert" key="unique">
                {error.data?.message || "Si è verificato un errore"}
                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>

    return content
}

export default ErrorMessage

// example of error
const example = {
    status: 403,
    data: {
        error: "Forbidden",
        message: "Insufficient permission"
    }

}